import { useMemo } from "preact/hooks";
import { ReadonlySignal, Signal, signal } from "@preact/signals";
import { Breakpoint } from "./interfaces";

const BREAKPOINTS = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
};

const breakpointStore: Partial<Record<Breakpoint, Signal<boolean>>> = {};

const getMatchSignal = (breakpoint: Breakpoint) => {
    if (breakpoint in breakpointStore) {
        return breakpointStore[breakpoint];
    }

    const query = window.matchMedia(`(min-width: ${BREAKPOINTS[breakpoint]})`);
    const state = signal(query.matches);
    query.onchange = (e) => {
        state.value = e.matches;
    };

    breakpointStore[breakpoint] = state;

    return state;
};

const useBreakpoint = (breakpoint: Breakpoint) => {
    const matches = useMemo(() => getMatchSignal(breakpoint), [breakpoint]);

    return matches as ReadonlySignal<boolean>;
};

export default useBreakpoint;
